import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Lottie from "react-lottie";
import * as location from "../Lottie/1055-world-locations.json";
import * as success from "../Lottie/1127-success.json";
import TextLoop from "react-text-loop";

import App from "../App";

const defaultOptions1 = {
  loop: true,
  autoplay: true,
  animationData: location.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const defaultOptions2 = {
  loop: true,
  autoplay: true,
  animationData: success.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function PreLoader2(props) {
  const [loading, setLoading] = useState(undefined);
  const [completed, setCompleted] = useState(false);
  const [language, setLanguage] = useState(undefined)

  const setPL = () =>{
    setLanguage("PL");
    setCompleted(true);
  }
  const setENG = () =>{
    setLanguage("ENG");
    setCompleted(true);
  }
  const setGER = () =>{
    setLanguage("GER");
    setCompleted(true);
  }
  const setESP = () =>{
    setLanguage("ESP");
    setCompleted(true);
  }


  useEffect(() => {
    const toggleCompleted = () => {
      setTimeout(() => {
        setCompleted(true);
      }, 1000);
    } 
  }, []);


  return (
    <>
      {!completed ? (
        <>

          {!loading ? (
            <>
              <div className="w-100 preloader-container d-flex align-items-center header-img">
                <div className="w-100 h-100">
                <div className="w-100 header-top d-flex align-items-center">
                  <Lottie
                    className="bg-dark"
                    options={defaultOptions1}
                    height={600}
                    width={600}
                    isClickToPauseDisabled={true}
                  />
                </div>
                <div className='col-12 mx-auto text-center header-countries text-warning'>
                  <h1>
                    <TextLoop interval='1750'>
                      <span>Wybierz język</span>
                      <span>Choose language</span>
                      <span>Sprache auswählen</span>
                      <span>Seleccione el idioma</span>
                    </TextLoop>
                  </h1>
                  
                  <div className='text-light mx-auto col-8 countries row'>
                    
                      <div className='col p-0 mx-auto'><img onClick={setPL} className='img-country' src='./img/pl.png' /></div>
                      <div className='col p-0 mx-auto'><img onClick={setENG} className=' img-country' src='./img/eng.png' /></div>
                    
                    
                      <div className='col p-0 mx-auto'><img onClick={setGER} className=' img-country' src='./img/ger.png' /></div>
                      <div className='col p-0 mx-auto disabled'><img disabled className='img-country ' alt='not available' src='./img/es.png' /></div>
                    
                  </div>
                </div>

                <div className="w-100 header-bottom"></div>
                </div>
              </div>

            </>
          ) : (
            <>
              <div className="w-100 header">
                <div className="w-100 header-top bg-dark d-flex align-items-center">
                  <Lottie options={defaultOptions2} height={400} width={400} />
                </div>
                <div className="w-100 bg-dark header-bottom"></div>
              </div>
            </>
          )}{" "}
        </>
      ) : (
        <App wait={1000} lang={language} />
      )}
    </>
  );
}

export default PreLoader2;
